import type { FunctionComponent, SVGProps } from 'react';
import TriangleKey from '@/assets/images/1-key-triangle-code.svg?react';
import HexagonKey from '@/assets/images/1-key-hexagon-code.svg?react';
import RectangleKey from '@/assets/images/1-key-rectangle-code.svg?react';
import { shuffle } from 'es-toolkit/array';

const KEYS: FunctionComponent<SVGProps<SVGSVGElement>>[] = shuffle([TriangleKey, HexagonKey, RectangleKey]);

export const ClueStep1 = () => (
  <div className="flex gap-4 md:gap-12 items-center justify-center h-full max-w-2/3">
    {KEYS.map((Key, index) => (
      <div key={index} className="relative w-32 h-64 flex items-center justify-center">
        <Key className="absolute inset-0 size-full text-beige drop-shadow-white drop-shadow-[0_0_40px]" />
      </div>
    ))}
  </div>
);
